/* tslint:disable */
/* eslint-disable */
import { NgModule, ModuleWithProviders, SkipSelf, Optional } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { ApiConfiguration, ApiConfigurationParams } from './api-configuration';

import { VehicleStatusControllerService } from './services/vehicle-status-controller.service';
import { DeadlineControllerService } from './services/deadline-controller.service';
import { DeactivationControllerService } from './services/deactivation-controller.service';
import { TelematicControllerService } from './services/telematic-controller.service';
import { PublicEventControllerService } from './services/public-event-controller.service';
import { MySvgControllerService } from './services/my-svg-controller.service';

/**
 * Module that provides all services and configuration.
 */
@NgModule({
  imports: [],
  exports: [],
  declarations: [],
  providers: [
    VehicleStatusControllerService,
    DeadlineControllerService,
    DeactivationControllerService,
    TelematicControllerService,
    PublicEventControllerService,
    MySvgControllerService,
    ApiConfiguration
  ],
})
export class KmasterBoxManagementModule {
  static forRoot(params: ApiConfigurationParams): ModuleWithProviders<KmasterBoxManagementModule> {
    return {
      ngModule: KmasterBoxManagementModule,
      providers: [
        {
          provide: ApiConfiguration,
          useValue: params
        }
      ]
    }
  }

  constructor( 
    @Optional() @SkipSelf() parentModule: KmasterBoxManagementModule,
    @Optional() http: HttpClient
  ) {
    if (parentModule) {
      throw new Error('KmasterBoxManagementModule is already loaded. Import in your base AppModule only.');
    }
    if (!http) {
      throw new Error('You need to import the HttpClientModule in your AppModule! \n' +
      'See also https://github.com/angular/angular/issues/20575');
    }
  }
}
